import React from 'react';
import { UserPlus, Shield, Loader2, Users } from 'lucide-react';

const UtilisateurBulkActions = ({ 
  selectedUtilisateurs, 
  bulkActionLoading, 
  onBulkActivate, 
  onBulkDeactivate,
  onOpenModal 
}) => {
  return (
    <div className="flex justify-between items-center">
      <div>
        <h2 className="text-xl font-semibold text-gray-900">Liste des Utilisateurs</h2>
        {selectedUtilisateurs.length > 0 && (
          <p className="text-sm text-gray-500 mt-1">
            {selectedUtilisateurs.length} utilisateur(s) sélectionné(s)
          </p>
        )}
      </div>
      
      <div className="flex items-center space-x-3">
        {/* Actions en lot */}
        {selectedUtilisateurs.length > 0 && (
          <div className="flex items-center space-x-2 mr-4">
            <button
              onClick={onBulkActivate}
              disabled={bulkActionLoading}
              className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-50"
            >
              {bulkActionLoading ? (
                <Loader2 className="h-4 w-4 mr-1 animate-spin" />
              ) : (
                <Users className="h-4 w-4 mr-1" />
              )}
              Activer
            </button>
            
            <button
              onClick={onBulkDeactivate}
              disabled={bulkActionLoading}
              className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50"
            >
              {bulkActionLoading ? (
                <Loader2 className="h-4 w-4 mr-1 animate-spin" />
              ) : (
                <Users className="h-4 w-4 mr-1" />
              )}
              Désactiver
            </button>
          </div>
        )}
        
        {/* Bouton d'ajout */}
        <button
          onClick={() => onOpenModal()}
          className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#202654] hover:bg-[#1a1f45] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#202654]"
        >
          <UserPlus className="h-5 w-5 mr-2" />
          Ajouter
        </button>
      </div>
    </div>
  );
};

export default UtilisateurBulkActions; 